var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-form",
          {
            ref: "detailForm",
            attrs: {
              model: _vm.detailForm,
              rules: _vm.rules,
              "label-width": "120px",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "评价月" } },
              [
                _c("el-input", {
                  staticStyle: { width: "100%" },
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.detailForm.month,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "month", $$v)
                    },
                    expression: "detailForm.month",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "指标类型" } },
              [
                _c("el-input", {
                  staticStyle: { width: "100%" },
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.detailForm.factorType,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "factorType", $$v)
                    },
                    expression: "detailForm.factorType",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "Facility名称" } },
              [
                _c("el-input", {
                  staticStyle: { width: "100%" },
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.detailForm.facilityName,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "facilityName", $$v)
                    },
                    expression: "detailForm.facilityName",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "状态" } },
              [
                _c("ic-select", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: "",
                    table: "TT_QSPI_FACILITY_FACTOR_SCORE",
                    field: "STATUS",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.detailForm.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "status", $$v)
                    },
                    expression: "detailForm.status",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "截止日期" } },
              [
                _c("el-input", {
                  staticStyle: { width: "100%" },
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.detailForm.deadline,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "deadline", $$v)
                    },
                    expression: "detailForm.deadline",
                  },
                }),
              ],
              1
            ),
            _vm.factorType === "SWA"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "审核评级", prop: "auditGrade" } },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.isDisabled || !_vm.isCanAudit,
                        table: "TT_QSPI_FACILITY_FACTOR_SCORE",
                        field: "AUDIT_GRADE",
                        placeholder: "请选择",
                      },
                      on: { change: _vm.auditGradeChange },
                      model: {
                        value: _vm.detailForm.auditGrade,
                        callback: function ($$v) {
                          _vm.$set(_vm.detailForm, "auditGrade", $$v)
                        },
                        expression: "detailForm.auditGrade",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                class:
                  _vm.factorType !== "AAA" &&
                  _vm.factorType !== "QBR" &&
                  _vm.factorType !== "MSV" &&
                  _vm.factorType !== "SWA" &&
                  _vm.factorType !== "SQMS" &&
                  _vm.factorType !== "SENSORY" &&
                  _vm.factorType !== "DQMP"
                    ? "is-required"
                    : "",
                attrs: { label: "等级", prop: "grade" },
              },
              [
                _vm.factorType === "SQMS"
                  ? _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.detailForm.grade,
                          callback: function ($$v) {
                            _vm.$set(_vm.detailForm, "grade", $$v)
                          },
                          expression: "detailForm.grade",
                        },
                      },
                      _vm._l(_vm.gradeOptions, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    )
                  : _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.isDisabled || !_vm.isCanAudit,
                        table: "TT_QSPI_FACILITY_FACTOR_SCORE",
                        field: "GRADE",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.detailForm.grade,
                        callback: function ($$v) {
                          _vm.$set(_vm.detailForm, "grade", $$v)
                        },
                        expression: "detailForm.grade",
                      },
                    }),
              ],
              1
            ),
            _vm.factorType == "SQMS"
              ? _c(
                  "el-form-item",
                  { attrs: { label: "分数", prop: "score" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "100%" },
                      attrs: { disabled: _vm.isDisabled || !_vm.isCanAudit },
                      on: { change: _vm.scoreChange },
                      model: {
                        value: _vm.detailForm.score,
                        callback: function ($$v) {
                          _vm.$set(_vm.detailForm, "score", $$v)
                        },
                        expression: "detailForm.score",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              { attrs: { label: "Comment" } },
              [
                _c("el-input", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "textarea",
                    disabled: _vm.isDisabled || !_vm.isCanAudit,
                    autosize: { minRows: 4, maxRows: 8 },
                    maxlength: "1000",
                    "show-word-limit": "",
                  },
                  model: {
                    value: _vm.detailForm.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailForm, "remark", $$v)
                    },
                    expression: "detailForm.remark",
                  },
                }),
              ],
              1
            ),
            _vm.factorType == "SQMS" && _vm.isCanAudit
              ? _c(
                  "el-form-item",
                  { attrs: { label: "Attachment List" } },
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "upload",
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          disabled: _vm.isDisabled,
                          "show-file-list": false,
                          "file-list": _vm.fileList,
                          headers: _vm.header,
                          action: "#",
                          "on-change": _vm.handleFileChange,
                          "before-remove": _vm.handleFileRemove,
                          "before-upload": _vm.beforeUpload,
                          "on-success": _vm.uploadSuccess,
                          "auto-upload": false,
                          multiple: true,
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              size: "small",
                              type: "primary",
                            },
                            slot: "trigger",
                          },
                          [_vm._v("选取文件")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "10px",
                        },
                        attrs: { type: "primary" },
                        on: { click: _vm.submitFileForm },
                      },
                      [_vm._v("确定")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.factorType === "SQMS"
              ? _c(
                  "el-row",
                  _vm._l(_vm.fileList, function (file, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          width: "calc(100% - 120px)",
                          "line-height": "40px",
                          "margin-left": "120px",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 21 } },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: file.documentName,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        staticClass: "other_link",
                                        staticStyle: {
                                          width: "90%",
                                          overflow: "hidden",
                                        },
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadFile(file)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(file.documentName))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.isCanAudit
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c("el-button", {
                                      staticClass: "delCircle",
                                      attrs: {
                                        type: "danger",
                                        icon: "el-icon-delete",
                                        circle: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delFile(file, index)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            !_vm.isDisabled && _vm.isCanAudit
              ? _c(
                  "el-row",
                  { attrs: { type: "flex", justify: "center" } },
                  [
                    _vm.detailForm.status !== "SCORED"
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value:
                                  (_vm.QSPI_MSV_SAVE,
                                  _vm.QSPI_SWA_SAVE,
                                  _vm.QSPI_SQMS_SAVE,
                                  _vm.QSPI_GOVTCERT_SAVE,
                                  _vm.QSPI_SPECCOMP_SAVE,
                                  _vm.QSPI_COA_SAVE,
                                  _vm.QSPI_REGCOMP_SAVE,
                                  _vm.QSPI_GOVTPLANT_SAVE,
                                  _vm.QSPI_OTHSTOCKRECOVER_SAVE,
                                  _vm.QSPI_PRDFEEDBACK_SAVE,
                                  _vm.QSPI_SENSORY_SAVE,
                                  _vm.QSPI_OTHQIP_SAVE,
                                  _vm.QSPI_ANTICHICK_SAVE,
                                  _vm.QSPI_OTHQBR_SAVE),
                                expression:
                                  "QSPI_MSV_SAVE,QSPI_SWA_SAVE,QSPI_SQMS_SAVE,QSPI_GOVTCERT_SAVE,QSPI_SPECCOMP_SAVE,QSPI_COA_SAVE,QSPI_REGCOMP_SAVE,QSPI_GOVTPLANT_SAVE,QSPI_OTHSTOCKRECOVER_SAVE,QSPI_PRDFEEDBACK_SAVE,QSPI_SENSORY_SAVE,QSPI_OTHQIP_SAVE,QSPI_ANTICHICK_SAVE,QSPI_OTHQBR_SAVE",
                              },
                            ],
                            attrs: { type: "primary" },
                            on: { click: _vm.onSave },
                          },
                          [_vm._v("保存")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value:
                              (_vm.QSPI_MSV_SUBMIT,
                              _vm.QSPI_SWA_SUBMIT,
                              _vm.QSPI_SQMS_SUBMIT,
                              _vm.QSPI_GOVTCERT_SUBMIT,
                              _vm.QSPI_SPECCOMP_SUBMIT,
                              _vm.QSPI_COA_SUBMIT,
                              _vm.QSPI_REGCOMP_SUBMIT,
                              _vm.QSPI_GOVTPLANT_SUBMIT,
                              _vm.QSPI_OTHSTOCKRECOVER_SUBMIT,
                              _vm.QSPI_PRDFEEDBACK_SUBMIT,
                              _vm.QSPI_SENSORY_SUBMIT,
                              _vm.QSPI_OTHQIP_SUBMIT,
                              _vm.QSPI_ANTICHICK_SUBMIT,
                              _vm.QSPI_OTHQBR_SUBMIT),
                            expression:
                              "QSPI_MSV_SUBMIT,QSPI_SWA_SUBMIT,QSPI_SQMS_SUBMIT,QSPI_GOVTCERT_SUBMIT,QSPI_SPECCOMP_SUBMIT,QSPI_COA_SUBMIT,QSPI_REGCOMP_SUBMIT,QSPI_GOVTPLANT_SUBMIT,QSPI_OTHSTOCKRECOVER_SUBMIT,QSPI_PRDFEEDBACK_SUBMIT,QSPI_SENSORY_SUBMIT,QSPI_OTHQIP_SUBMIT,QSPI_ANTICHICK_SUBMIT,QSPI_OTHQBR_SUBMIT",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit },
                      },
                      [_vm._v("提交")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }